export const k6Meta = () => {
    return {
        k6: {
            isK6Browser: true,
        },
    };
};
//# sourceMappingURL=meta.js.map